import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit,  faEllipsis, faCheckCircle, faExclamationCircle, faDownload, faRefresh } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { uploadWinners, winnersSummery, changeBatchStatus, deleteBatch } from "../../../controllers/V1/lottoWinners/lottoWinnersControllers";
import { getPage } from "../../../controllers/common";

import PreviewPopUp from "./PreviewPopUp";
import { usePermissions } from "../../../controllers/PermissionContext";
import {formatProjectDate} from "../../../controllers/common"
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};



export default function BasicTabs() {
  const PERMISSION = usePermissions("lottoWinner");
  const [isPreviewShow, setPreviewShow] = useState(false);
  const togglePreview = () => setPreviewShow(!isPreviewShow);

  const [uploadFile, setUploadFile] = useState('');
  const [error, setError] = useState({});


  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
 
  const fileRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");

  const [selectedList, setSelectedList] = useState([]);

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          // ...(filter?.filter_by === 'order_no'?{order_no : filter?.search }:null),
          // ...(filter?.filter_by === 'coupon_code'?{coupon_code : filter?.search }:null),
          // ...(filter?.filter_by === 'title'?{title : { $regex: filter?.search, $options: "i" } }:null),
          // ...(filter?.filter_by === 'name'?{name : { $regex: filter?.search, $options: "i" } }:null),
          // ...(filter?.filter_by === 'mobile'?{mobile : parseInt(filter?.search) }:null),
          // ...(filter?.filter_by === 'prize'?{prize : { $regex: filter?.search, $options: "i" } }:null),
          
          // ...(filter?.from?{createdAt : {$gte : new Date(`${filter.from} 0:01:00`), $lte : new Date(`${filter.from} 23:59:00`)} }:null),
          // ...(showRequest ? { status: showRequest } : null),
        },
        // select: {},
        // sort: { status: 1, _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await winnersSummery(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Crown King || Lotto Winner's list";
    setSelectedList([]);
  }, [currentPage, showRequest, filter]);

  const handleEdit = (items) => {
    navigate('/lotto-winners/detailed-list', { state: items });
  }

  const handleDelete = async (id = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ ids_list : [id] };
        const res = await deleteBatch(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Data deleted successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error while procession`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

  const handleUpload = async () => {
    try {
      if(!uploadFile){
        setError((pre)=>({
          ...pre,
          file : "File is required."
        }))
      } else if(uploadFile.type === 'application/vnd.ms-excel' || uploadFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        setIsLoading(true);
        const form = new FormData();
        form.append('file',uploadFile);
        const res = await uploadWinners(form);
        if(res.status === true){
          setUploadFile("");
          getList();
          fileRef.current.value ='';
        }else{
          setError((pre)=>({
            ...pre,
            file : res.status
          }));
          setUploadFile("");
        }
      } else{
        setError((pre)=>({
          ...pre,
          file : `File format not supported. Only xlsx and xls formats are allowed.`
        }));
        setUploadFile("");
      }
    } catch (error) {
      setUploadFile("");
      setIsLoading(false);
    }
  }

  const onFileChange = (e) =>{
    try {
      const upload_file = e.target.files[0];
      // console.log('upload_file.type : ',upload_file.type);
      if(upload_file.type === 'application/vnd.ms-excel' || upload_file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        setUploadFile(upload_file);
        setError((pre)=>({
          ...pre,
          file : ""
        }));
      } else{
        setError((pre)=>({
          ...pre,
          file : `File format not supported. Only xlsx and xls formats are allowed.`
        }));
        fileRef.current.value = '';
        setUploadFile("");
      }
    } catch (error) {
      console.log('error',error);
    }
  }

  const handleCleatBtn = () => {
    try {
      setUploadFile("");
      fileRef.current.value = '';
      const updatedData = ALLLISTDATA.map((item) => ({
        ...item,
        selected: false
      }));
      setListData(updatedData);
      setError({});
    } catch (error) {
      console.log('error',error);
    }
  }

  const toggleSelect = async (item_id) =>{
    try {
      const updatedData = ALLLISTDATA.map((item) => ({
        ...item,
        selected: item.batch_id === item_id ? !item.selected : item.selected
      }));
      setListData(updatedData);
    } catch (error) {
      console.log('error',error);
    }
  }

const handleBulkDelete =async () =>{
  try {
    const selectedIds = ALLLISTDATA.reduce((acc, item) => {
      if (item.selected === true) acc.push(item.batch_id);
      return acc;
    }, []);
    if(selectedIds?.length > 0){
      const options = { ids_list : selectedIds }
      const res = await deleteBatch(options);
      if(res.status === true){
        getList();
        notification.open({
          message: "Success",
          description: `Data deleted successfully..`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } else {
      notification.open({
        message: "Oops!",
        description: `Please select batch.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
    // console.log('selectedIds',selectedIds);
  } catch (error) {
    
  }
}

const handleBulkInactive =async () =>{
  try {
    const selectedIds = ALLLISTDATA.reduce((acc, item) => {
      if (item.selected === true) acc.push(item.batch_id);
      return acc;
    }, []);
    if(selectedIds?.length > 0){
      const option = { 
        ids_list  : selectedIds,
        status    : "Inactive"
      }
      const res = await changeBatchStatus(option);
      if(res.status === true){
        getList();
        notification.open({
          message: "Success",
          description: `Data updated successfully..`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } else{
      notification.open({
        message: "Oops!",
        description: `Please select batch.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
    // console.log('selectedIds',selectedIds);
  } catch (error) {
    
  }
}

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Lotto winner's list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <div className="inventory_all_tabs">
                  <div className="all_tabs_value">
                    <Link to={`/templates/lotto winners.xls`} target="__blank" className="form-control store_input_field" style={{textDecoration : 'none'}}><FontAwesomeIcon icon={faDownload} /> Sample</Link>
                  </div>
                  <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                    <input type="file" name="file" id="file" accept=".xlsx, .xls" onChange={onFileChange} ref={fileRef} className="form-control store_input_field" />
                  </div>
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.upload === 'Y') && (<>
                    {/* <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                      <button type="button" className="form-control store_input_field" onClick={handleUpload} disabled={isLoading}>Upload</button>
                    </div> */}

                    <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                      <button type="button" className="form-control store_input_field" onClick={togglePreview}>Preview</button>
                    </div>
                  </>)}
                  {/* {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.delete === 'Y') && (
                    <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                      <button type="button" className="form-control store_input_field" onClick={handleBulkDelete}>Delete Selected</button>
                    </div>
                  )} */}
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.changeStatus === 'Y') && (
                    <div className="fa_filter_rating_review filter_img_and_add_btn_main"  >
                      <button type="button" className="form-control store_input_field" onClick={handleBulkInactive}>Inactive Selected</button>
                    </div>
                  )}
                  <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                    <button type="button" className="form-control store_input_field" onClick={handleCleatBtn}>Clear</button>
                  </div>
                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>getList()}><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
              </div>
                {error?.file&&(<p style={{color : "red"}}>{error?.file}</p>)}
            </Box>       
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Batch No.</th>
                              <th>Details</th>
                              <th>Created Date & Time</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} onClick={()=>toggleSelect(items?.batch_id)}>
                                    <td>
                                      <input type="checkbox" className="form-check-input" checked={items.selected === true} />
                                      {" "}
                                      {SKIP + index + 1}
                                    </td>
                                    <td>{items?.batch_id}</td>
                                    <td>
                                      Total Winners : {items?.orderCount || 0} <br/>
                                      Total Winning Amount : {items?.total_points?.toFixed(2) || 0} <br/>
                                      Total Redeemed Amount : {items?.redeemedPoints?.toFixed(2) || 0} <br/>
                                      Total Amount Unpaid : {parseFloat(items?.total_points) - parseFloat(items?.redeemedPoints)} <br/>
                                      File : {items?.file || 'N/A'
                                      }
                                    </td>
                                    <td>{formatProjectDate(items?.created_date)}</td>
                                    <td>
                                      Active : {items?.activeCount || 0} <br/>
                                      Inactive : {items?.inactiveCount || 0} <br/>
                                      Redeemed : {items?.redeemedCount || 0} <br/>
                                    </td>
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.details === 'Y') && (
                                              <Menu.Item key={`1`} onClick={() => { handleEdit(items) }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Details</span>
                                              </Menu.Item>
                                            )}
                                            {/* {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.delete === 'Y') && (
                                              <Menu.Item key={`4`} onClick={() => handleDelete(items?.batch_id)} >
                                                <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Delete</span>
                                              </Menu.Item>
                                            )} */}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={6} /> : <tr> 
                                <td colspan="6" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      <PreviewPopUp popUpOpen={isPreviewShow} togglePopUp={togglePreview} upload_file={uploadFile} process={handleUpload} />
    </>
  );
}
